import { NgModule } from '@angular/core';
import { HeroComponent } from './hero.component';
import { CommonModule } from '@angular/common';
import {PipesModule} from '../../pipes.module';

@NgModule({
  imports: [
    CommonModule,
    PipesModule
  ],
  declarations: [
    HeroComponent
  ],
  exports: [
    HeroComponent
  ]
})
export class HeroModule { }
